import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {AuthService} from "./auth.service";
import {UsersService} from "..";
import {from, Observable} from "rxjs";
import {mergeMap} from "rxjs/operators";
import {HelperService} from "../helperService";
import {ENVIRONMENT} from "../../../environments/environment";


/**
 * Class AuthResolver
 */
@Injectable()
export class AuthResolver
{


	/**
	 * Function > constructor
	 * @param {NavigationService} OBJ_navigation_service
	 * @param {AuthService} OBJ_auth_service
	 * @param {UsersService} OBJ_user_service
	 * @param {HelperService} OBJ_helper_service
	 */
    constructor
	(
        private OBJ_navigation_service: NavigationService,
        private OBJ_auth_service: AuthService,
		private OBJ_user_service: UsersService,
		private OBJ_helper_service: HelperService
	) {} // end function constructor


    /**
     * Function > resolve
     * @param {ActivatedRouteSnapshot} OBJ_route
     * @param {RouterStateSnapshot} OBJ_state
     * @return {Observable<any>}
     */
    resolve (OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): Observable<any>
	{

		this.OBJ_helper_service.logWithClassAndFunction("AuthResolver", "resolve", OBJ_route, OBJ_state);

		if (typeof OBJ_route.queryParams["token"] !== 'undefined') {
			// set access object
			let STR_token = this.OBJ_helper_service.decrypt(OBJ_route.queryParams["token"], true);
			this.OBJ_helper_service.setInLocalstorage('access', STR_token);

			// get config
			let OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');

			return this.OBJ_auth_service.auth(OBJ_config.auth.url_auth)
				.pipe(
				mergeMap
				(
					// login successful
					OBJ_data => {

						let OBJ_client = this.setClient();

						this.OBJ_helper_service.logWithClassAndFunction("AuthResolver", "resolve", OBJ_client);

						// Fetch Navigation and cache it in local Storage
						return from(this.OBJ_navigation_service.load(OBJ_client.id, OBJ_client.roles[0].id)
							.then(OBJ_response => {

								// set client
								this.OBJ_helper_service.setInLocalstorage('client', OBJ_client);

								return true;
							}));
					}
				));

		} // end if

	} // end function resolve


	/**
	 * Function > setClient
	 * @param {string} STR_navigate
	 * @return any
	 */
	private setClient(STR_navigate: string = ""): any
	{

		let OBJ_current_user = this.OBJ_helper_service.getFromLocalstorage("current_user");
		let OBJ_client: any = null;

		// user account ist active?
		if (OBJ_current_user.active) {

			OBJ_current_user.clients.forEach((OBJ_item) => {

				let STR_client_url = OBJ_item.webaddress;

				// Non-Production-Environments have slightly different url
				if(ENVIRONMENT.env !== 'production')
				{
					// if www is set (not always the case) delete it
					STR_client_url = STR_client_url.replace('www', '');

					// url sometimes starts with a subdomain other than www
					if(!STR_client_url.startsWith("."))
					{
						STR_client_url = "." + STR_client_url;
					} // end if

					// append environmental subdomain (usually dev or preview)
					STR_client_url = ENVIRONMENT.location.subdomain + STR_client_url + ".internal";
				} // end if

				if (STR_client_url == window.location.hostname) {

					OBJ_client = OBJ_item;
				} // end if
			});

		} // end if

		return OBJ_client;

	} // end function setClient


} // end class AuthResolver
